import type { ReleaseChange } from '../data/releaseNotes'

/** Where the "Essayer" button of a release note sends the user. */
export interface FeatureTarget {
  /** Sidebar tab id */
  tab: string
  subTab?: 'gerer' | 'analytiques' | 'configurer'
  /** Communications only: open the notice composer instead of the list. */
  view?: 'list' | 'composer'
}

const OVERRIDES: Record<string, FeatureTarget> = {
  '4.6.0:0': { tab: 'requetes', subTab: 'gerer' },
  '4.6.0:1': { tab: 'requetes', subTab: 'gerer' },
  '4.6.0:2': { tab: 'requetes', subTab: 'gerer' },
  '4.6.0:3': { tab: 'requetes', subTab: 'gerer' },
  '4.4.0:1': { tab: 'bciti', subTab: 'configurer' },
  '4.4.0:2': { tab: 'bciti', subTab: 'gerer', view: 'list' },
}

export function getTryTarget(version: string, index: number, change: ReleaseChange): FeatureTarget {
  const override = OVERRIDES[`${version}:${index}`]
  if (override) return override
  switch (change.module) {
    case 'communications':
      return { tab: 'bciti', subTab: 'gerer', view: 'composer' }
    case 'id':
      return { tab: 'bciti-id' }
    case 'permis':
      return { tab: 'permis' }
    case 'loisirs':
      return { tab: 'loisirs' }
    case 'requetes':
    case 'plateforme':
    default:
      return { tab: 'requetes', subTab: 'analytiques' }
  }
}
